import React from 'react';
import { Button, Input, InputUI, ModalBox } from '@fourthwall/components';
import { useFormik } from '@fourthwall/utils/dist/formik';
import * as S from './GenerateCodesModal.styled';
import { FormFields } from './GenerateCodesModal.types';
import { validationSchema } from './consts';
export const GenerateCodesModal = ({ title, prefixExample = 'PROMO', onSubmit, close, }) => {
    const formik = useFormik({
        initialValues: {
            quantity: undefined,
            prefix: undefined,
        },
        validationSchema,
        onSubmit: (values) => {
            onSubmit(values);
            close();
        },
    });
    return (React.createElement("form", { onSubmit: formik.handleSubmit },
        React.createElement(ModalBox, { title: title, buttons: [
                React.createElement(Button, { label: "Cancel", onClick: close }),
                React.createElement(Button, { label: "Generate codes", type: "submit", appearance: "primary", disabled: !formik.isValid || !formik.dirty }),
            ], size: "small", onClose: close },
            React.createElement(S.Info, null, "How many codes would you like to generate?"),
            React.createElement(S.QuantityContainer, null,
                React.createElement(S.InputContainer, null,
                    React.createElement(Input, { label: "Quantity", type: "number", hideSpinner: true, displayError: false, ...formik.getFieldProps(FormFields.quantity) })),
                formik.errors.quantity && React.createElement(InputUI.Error, null, formik.errors.quantity)),
            React.createElement(S.Info, null,
                "What name would you like to appear before each code? (e.g. ",
                prefixExample,
                " will create",
                ' ',
                prefixExample,
                "_SJ2F, etc.)"),
            React.createElement(S.InputContainer, null,
                React.createElement(Input, { label: "Prefix (optional)", ...formik.getFieldProps(FormFields.prefix) })))));
};
